import { Bot, RefreshCw } from "lucide-react";

import type { Agente } from "@/hooks/useAdminAgenti";
import { cn } from "@/lib/utils";

function rel(iso: string | null | undefined): string {
  if (!iso) return "—";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "ora";
  if (s < 3600) return `${Math.floor(s / 60)} min fa`;
  if (s < 86400) return `${Math.floor(s / 3600)} h fa`;
  return `${Math.floor(s / 86400)} gg fa`;
}

export function AgenteHero({
  agente,
  onRefresh,
  fetching,
}: {
  agente: Agente;
  onRefresh: () => void;
  fetching: boolean;
}) {
  const attivo = agente.stato === "attivo";
  return (
    <div className="flex flex-wrap items-center gap-4 rounded-xl border bg-card p-5">
      <div className="relative grid size-14 shrink-0 place-items-center rounded-2xl bg-brand-50">
        <Bot className="size-7 text-brand-700" />
        <span className="absolute -bottom-1.5 -right-1.5 rounded-md border-2 border-card bg-slate-900 px-1 py-0.5 text-[8px] font-bold tracking-wide text-white">
          AI
        </span>
      </div>
      <div className="min-w-0">
        <h1 className="text-xl font-bold tracking-tight">{agente.nome}</h1>
        <div className="text-sm text-muted-foreground">
          {agente.ruolo} · Modulo {agente.modulo}
          {agente.referente ? ` · referente umano: ${agente.referente}` : ""}
        </div>
        <span
          className={cn(
            "mt-1.5 inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold",
            attivo ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500",
          )}
        >
          <span
            className={cn("size-2 rounded-full", attivo ? "bg-emerald-500" : "bg-slate-400")}
          />
          {attivo
            ? `Attivo · ultima attività ${rel(agente.ultima_attivita_il)}`
            : "In arrivo"}
        </span>
      </div>
      {attivo && (
        <button
          type="button"
          onClick={onRefresh}
          className="ml-auto inline-flex items-center gap-1.5 rounded-md border bg-card px-3 py-1.5 text-sm font-semibold text-slate-700 hover:bg-muted"
        >
          <RefreshCw className={cn("size-3.5", fetching && "animate-spin")} /> Aggiorna
        </button>
      )}
    </div>
  );
}
